import { MoneyTwoTone } from "@mui/icons-material";

export const PricesTabHeader = () => {
  return (
    <span style={{ display: "" }}>
      <MoneyTwoTone /> <span style={{ verticalAlign: "super" }}>Prices</span>
    </span>
  );
};
